module.exports = __webpack_public_path__ + "static/media/mobile.538b3a56.png";